import Home from './Home.view.vue';

export default {
  path: '/',
  name: 'home',
  component: Home,
};
